var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 60 60",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_04---Mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 21v16c0 .552-.448 1-1 1h-5c.507.005.995-.189 1.36-.54.405-.378.636-.906.64-1.46v-14c0-1.105-.895-2-2-2h-15.96c.502-5.884 5.561-10.322 11.461-10.054s10.534 5.148 10.499 11.054z",
    fill: "#c81e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    d: "m58 21v16c0 .552-.448 1-1 1h-28c.552 0 1-.448 1-1v-16c.002-2.918-1.157-5.717-3.22-7.78s-4.862-3.222-7.78-3.22h28c2.918-.002 5.717 1.157 7.78 3.22s3.222 4.862 3.22 7.78z",
    fill: "#f44335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    d: "m47 10h-3c2.918-.002 5.717 1.157 7.78 3.22s3.222 4.862 3.22 7.78v16c0 .552-.448 1-1 1h3c.552 0 1-.448 1-1v-16c.002-2.918-1.157-5.717-3.22-7.78s-4.862-3.222-7.78-3.22z",
    fill: "#c81e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m45 28h8c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1h-8c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1z",
    fill: "#ffeb3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    d: "m36 0h8c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1h-9v-5c0-.552.448-1 1-1z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    d: "m44 0h-3c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1h3c.552 0 1-.448 1-1v-4c0-.552-.448-1-1-1z",
    fill: "#fec108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    d: "m39.778 58h-8.556c-.612.055-1.155-.39-1.222-1v-19h11v19c-.067.61-.61 1.055-1.222 1z",
    fill: "#91562d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    d: "m38 38v19c-.067.61-.61 1.055-1.222 1h3c.612.055 1.155-.39 1.222-1v-19z",
    fill: "#6d4122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    d: "m10.27 29.31-9.63 8.15c-.405-.378-.636-.906-.64-1.46v-14c0-.391.115-.773.33-1.1z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    d: "m25.36 37.46c-.365.351-.853.545-1.36.54h-22c-.507.005-.995-.189-1.36-.54l9.63-8.15 1.44 1.22c.745.629 1.835.629 2.58 0l1.44-1.22z",
    fill: "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    d: "m26 22v14c-.004.554-.235 1.082-.64 1.46l-9.63-8.15 9.94-8.41c.215.327.33.709.33 1.1z",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    d: "m25.67 20.9-9.94 8.41-1.44 1.22c-.745.629-1.835.629-2.58 0l-1.44-1.22-9.94-8.41c.37-.562.997-.9 1.67-.9h22c.673 0 1.3.338 1.67.9z",
    fill: "#ffeb3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    d: "m48 10h-11v-2h8c1.103-.003 1.997-.897 2-2v-4c-.003-1.103-.897-1.997-2-2h-8c-1.103.003-1.997.897-2 2v8h-15c-5.865-.027-10.88 4.212-11.83 10h-5.17c-1.655.005-2.995 1.345-3 3v14c.005 1.655 1.345 2.995 3 3h27v18c.068 1.162 1.057 2.053 2.22 2h8.56c1.163.053 2.152-.838 2.22-2v-18h15c1.103-.003 1.997-.897 2-2v-16c-.006-6.625-5.375-11.994-12-12zm-11-8h8v4h-8zm-12 20-10.36 8.77c-.371.309-.909.309-1.28 0l-10.36-8.77zm-23 14.85v-13.07l7.72 6.53zm1.73 1.15 7.54-6.38.79.67c1.12.947 2.76.947 3.88 0l.79-.67 7.54 6.38zm22.27-1.15-7.72-6.54 7.72-6.53zm4 1.15h-2.18c.116-.321.177-.659.18-1v-14c-.005-1.655-1.345-2.995-3-3h-14.8c1.022-5.035 5.693-8.476 10.805-7.959s9 4.822 8.995 9.959zm10.78 20h-8.517c-.206 0-.261-.099-.262-.088l-.001-17.912h3v15c0 .552.448 1 1 1s1-.448 1-1v-15h4l.02 17.92c0 .024-.082.08-.24.08zm17.22-20h-26v-16c-.002-4.025-2.022-7.781-5.38-10h21.38c5.519.009 9.991 4.481 10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    d: "m54 28h-8c-1.103.003-1.997.897-2 2v4c.003 1.103.897 1.997 2 2h8c1.103-.003 1.997-.897 2-2v-4c-.003-1.103-.897-1.997-2-2zm0 6h-8v-4h8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    d: "m11 26h6c.552 0 1-.448 1-1s-.448-1-1-1h-6c-.552 0-1 .448-1 1s.448 1 1 1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.42e0750e7e30127034e5ab11cf316365.svg";
export { ForwardRef as ReactComponent };